import React from "react";
import styles from "./index.module.scss";
import SearchComponent from "../search-component";
import { OverlayPanel } from "primereact/overlaypanel";

interface propsType {
  searchRef: React.RefObject<OverlayPanel>;
}

export default function SearchModel({ searchRef }: propsType) {
  return (
    <OverlayPanel ref={searchRef} className={styles.SearchModel}>
      <SearchComponent searchRef={searchRef} />
    </OverlayPanel>
  );
}
